import { stringRequiredSchema } from "utils/validation/validationHelpers";
import { object } from 'yup';

const addStatusSchema = object().shape({
    title: stringRequiredSchema,
    status: stringRequiredSchema
});

export default addStatusSchema;